import IconButton from 'components/atoms/button/IconButton';
import ConditionalRender from 'components/atoms/conditional-render/ConditionalRender';
import FilterBorderedWrapper from 'components/atoms/filter-bordered-wrapper/FilterBorderedWrapper';
import Headline from 'components/atoms/headline/Headline'
import Icon from 'components/atoms/icon/Icon';
import Input from 'components/atoms/input/Input';
import DashboardBoxTitle from 'components/atoms/title/DashboardBoxTitle';
import DynamicDropdown from 'components/molecules/dynamic-dropdown/DynamicDropdown';
import ConfigureTableDropdown from 'components/organisms/leads/dropdowns/ConfigureTableDropdown';
import DashboardBoxLayout from 'components/templates/dashboard-box-layout/DashboardBoxLayout';
import { TeamHeaders } from 'lib/helpers/constants/columns/teamHeaders';
import { IconType } from 'lib/helpers/constants/iconTypes';
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import CreateAndUpdateTeam from './create-update-team/CreateAndUpdateTeam';
import { useTeams } from 'lib/hooks/queries/Settings/useTeams';
import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen';
import NoDataBoundary from 'components/atoms/no-data-boundary/NoDataBoundary';
import EmptyEntity from 'components/atoms/empty-entity/EmptyEntity';
import TeamsTable from './teams-table/TeamsTable';
import { usePermissions } from 'lib/hooks/shared/usePermissions';
import { useLocation } from 'react-router-dom';

const TeamsView = () => {

    const { t } = useTranslation();

    const [configureTableOpen, setConfigureTableOpen] = useState<boolean>(false);
    // const [filterTableOpen, setFilterTableOpen] = useState<boolean>(false);

    const { pathname } = useLocation()

    const isBroker = useMemo(() => {
        return pathname.includes('brokers');
    }, [pathname]);

    const [filterData, setFilterData] = useState<any>({
        search: "",
        status: "",
        date_of_creation: undefined,
        type: isBroker ? 'broker' : 'internal'
    });

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [cardsOrder, setCardsOrder] = useState(TeamHeaders(isBroker));

    const hasPermissionToCreateTeam = usePermissions(['data_sharing_teams_create']);

    const { data, isLoading } = useTeams(filterData);

    return (
        <div>
            <Headline title="Data Sharing" />
            <DashboardBoxLayout>
                <div className="flex gap-3 items-center justify-between mb-5">
                    <div className="flex-1">
                        <DashboardBoxTitle
                            title={`${isBroker ? t('Data Sharing Brokers') : t('Data Sharing Teams')}`}
                        />
                    </div>
                    <ConditionalRender condition={hasPermissionToCreateTeam}>
                        <IconButton
                            icon={<Icon color="#fff" iconType={IconType.PLUS_ICON} />}
                            onClick={() => {
                                setIsModalOpen(true);
                            }}
                        >
                            {t('New Team')}
                        </IconButton>
                    </ConditionalRender>
                </div>
                <div className="flex gap-3 items-center mb-5 flex-wrap md:flex-nowrap justify-end">
                    <div className="flex-1 basis-full md:basis-auto">
                        <Input
                            icon={IconType.SEARCH_ICON}
                            className=" border-0 !border-[#F2F4F7] indent-[35px] h-[48px] !rounded-[8px] text-[#7D8592] font-inter-regular shadow-customsecondary"
                            classes={{ icon: "left-4 !top-[30%]" }}
                            placeholder={t("Search")}
                            onChange={(e) =>
                                setFilterData((prevFormData: any) => ({
                                    ...prevFormData,
                                    search: e.target.value
                                }))
                            }
                            maxLength={20}
                        />
                    </div>
                    <div className="flex flex-row gap-2">
                        <div className="flex-none ">
                            <div className={`relative`}>
                                <FilterBorderedWrapper
                                    className="cursor-pointer h-[48px] w-[48px] "
                                    onClick={() => {
                                        setConfigureTableOpen(!configureTableOpen);
                                    }}
                                >
                                    <Icon iconType={IconType.FILTER_BARS_ICON} />
                                </FilterBorderedWrapper>
                                <ConditionalRender condition={configureTableOpen}>
                                    <DynamicDropdown
                                        setIsOpen={setConfigureTableOpen}
                                        showCloseButton={true}
                                        title={t("Configure Table")}
                                    >
                                        <ConfigureTableDropdown
                                            setCardsOrder={setCardsOrder}
                                            cardsOrder={cardsOrder}
                                        />
                                    </DynamicDropdown>
                                </ConditionalRender>
                            </div>
                        </div>
                        {/* <div className="flex-none">
                            <div className={`${filterTableOpen && "relative"}`}>
                                <FilterBorderedWrapper
                                    className="h-[48px] w-[48px] cursor-pointer"
                                    onClick={() => {
                                        setFilterTableOpen(!filterTableOpen);
                                    }}
                                >
                                    <Icon iconType={IconType.FILTER_ICON} />
                                </FilterBorderedWrapper>
                                <ConditionalRender condition={filterTableOpen}>
                                    <DynamicDropdown
                                        setIsOpen={setFilterTableOpen}
                                        showCloseButton={true}
                                        title={t("Filter")}
                                        className="sm:!w-[350px]"
                                    >
                                        <FilterTableDropdown
                                            setFilterData={setFilterData}
                                            filterData={filterData}
                                            setIsOpen={setFilterTableOpen}
                                        />
                                        <>
                                        </>
                                    </DynamicDropdown>
                                </ConditionalRender>
                            </div>
                        </div> */}

                    </div>
                </div>

                <div className="relative">
                    {isLoading && <LoadingScreen />}
                    <NoDataBoundary
                        condition={(data as any)?.data?.length > 0}
                        fallback={<EmptyEntity name={t("Teams")} />}
                    >
                        <TeamsTable
                            data={(data as any)?.data ?? []}
                            dataCols={cardsOrder}
                        />
                    </NoDataBoundary>
                </div>
            </DashboardBoxLayout>
            <CreateAndUpdateTeam
                clearData={true}
                hocClasses={{
                    modalClassName: "w-full sm:max-w-[550px]"
                }}
                onConfirm={() => {
                    setIsModalOpen(false);
                }}
                hocTitle={'Create New Team'}
                hocCurrentStep={1}
                hocToggleModal={() => { setIsModalOpen(!isModalOpen) }}
                hocisOpen={isModalOpen}
                hocHasChanges={false}
            />
        </div>
    )
}

export default TeamsView